module.exports = __webpack_public_path__ + "static/media/detailedSubtractHorse.7af6ebcb.svg";